import React from 'react'

export default function Button({children, onClick, className, disabled}) {
  return (
    <button disabled={disabled} onClick={onClick} className={`${className} rounded-md px-4 py-2`}>{children}</button>

  )
}
